import { render, staticRenderFns } from "./InputCheck.vue?vue&type=template&id=0fe6bc1a&"
import script from "./InputCheck.ts?vue&type=script&lang=ts&"
export * from "./InputCheck.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports